"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useExternalMappingCsvUploadBase = exports.useVoucherAttachmentUploadBase = exports.useVoucherUploadBase = exports.useFileUploadBase = exports.FileUploadStatus = void 0;
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var const_1 = require("remota-common/const");
var loading_1 = require("./loading");
var notification_1 = require("./notification");
exports.FileUploadStatus = {
    WAITING: "wairing",
    URL_GENERATING: "preparing",
    UPLOADING: "uploading",
    UPLOADED: "uploaded",
    DONE: "done",
};
var toFileUploadStatus = function (urlStatus, uploadStatus, doneStatus) {
    if (doneStatus.isLoaded) {
        return exports.FileUploadStatus.DONE;
    }
    else if (uploadStatus.isLoaded) {
        return exports.FileUploadStatus.UPLOADED;
    }
    else if (uploadStatus.isLoading) {
        return exports.FileUploadStatus.UPLOADING;
    }
    else if (urlStatus.isLoaded) {
        return exports.FileUploadStatus.UPLOADING;
    }
    else if (urlStatus.isLoading) {
        return exports.FileUploadStatus.URL_GENERATING;
    }
    else {
        return exports.FileUploadStatus.WAITING;
    }
};
var useFileUploadBase = function (params, loadingState, requestUrl, finishUrl, onFinish, onFailure) {
    var _a, _b, _c, _d, _e, _f;
    var _g = __read((0, react_1.useState)({ file: undefined, info: undefined }), 2), state = _g[0], setState = _g[1];
    var setInfo = (0, react_1.useCallback)(function (info) {
        setState({ file: state.file, info: info });
    }, [state.file]);
    var handleFinish = (0, react_1.useCallback)(function () {
        onFinish(state);
    }, [onFinish, state]);
    var handleFailure = (0, react_1.useCallback)(function () {
        onFailure(state);
    }, [onFailure, state]);
    var uploadOption = (0, react_1.useMemo)(function () {
        var _a;
        return ({
            headers: (_a = {}, _a[const_1.TOKEN_HEADER_KEY] = undefined, _a),
            params: { t: undefined },
        });
    }, []);
    var uploadStatus = (0, loading_1.useHttpPut)(loadingState, (_b = (_a = state.info) === null || _a === void 0 ? void 0 : _a.uploadUrl) !== null && _b !== void 0 ? _b : "", state.file, ((_c = state.info) === null || _c === void 0 ? void 0 : _c.uploadUrl) !== undefined && state.file !== undefined, undefined, handleFailure, uploadOption);
    var urlStatus = (0, loading_1.useHttpPost)(loadingState, requestUrl, __assign(__assign({}, params), { fileName: (_d = state.file) === null || _d === void 0 ? void 0 : _d.name }), state.file !== undefined, setInfo, handleFailure);
    var doneRequest = (0, react_1.useMemo)(function () {
        var _a, _b;
        var fileId = (_a = state.info) === null || _a === void 0 ? void 0 : _a.fileId;
        if (!fileId || !uploadStatus.isLoaded) {
            return undefined;
        }
        var success = uploadStatus.error === null;
        return __assign(__assign({}, params), { fileId: fileId, fileName: (_b = state.file) === null || _b === void 0 ? void 0 : _b.name, success: success });
    }, [params, (_e = state.file) === null || _e === void 0 ? void 0 : _e.name, (_f = state.info) === null || _f === void 0 ? void 0 : _f.fileId, uploadStatus.error, uploadStatus.isLoaded]);
    var doneStatus = (0, loading_1.useHttpPost)(loadingState, finishUrl, doneRequest, doneRequest !== undefined, handleFinish, handleFailure);
    var upload = (0, react_1.useCallback)(function (file) {
        setState({ file: file, info: undefined });
    }, []);
    return (0, react_1.useMemo)(function () { return [upload, toFileUploadStatus(urlStatus, uploadStatus, doneStatus)]; }, [
        upload,
        uploadStatus,
        urlStatus,
        doneStatus,
    ]);
};
exports.useFileUploadBase = useFileUploadBase;
var useVoucherUploadBase = function (loadingState, jobInputId, jobId, isExternal) {
    var params = (0, react_1.useMemo)(function () { return ({ jobInputId: jobInputId, jobId: jobId }); }, [jobInputId, jobId]);
    var _a = __read((0, react_i18next_1.useTranslation)(), 1), t = _a[0];
    var notify = (0, notification_1.useNotify)();
    var onUploadFinish = (0, react_1.useCallback)(function (state) {
        var _a, _b;
        notify({
            message: isExternal
                ? "".concat((_a = state.file) === null || _a === void 0 ? void 0 : _a.name, "\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3057\u307E\u3057\u305F\u3002")
                : t("voucher.upload.success", { name: (_b = state.file) === null || _b === void 0 ? void 0 : _b.name }),
            severity: "success",
        });
    }, [notify, t, isExternal]);
    var onUploadFailure = (0, react_1.useCallback)(function (state) {
        var _a, _b;
        // TODO: エラー内容を出し分けしたい
        notify({
            message: isExternal
                ? "".concat((_a = state.file) === null || _a === void 0 ? void 0 : _a.name, "\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002")
                : t("voucher.upload.error", { name: (_b = state.file) === null || _b === void 0 ? void 0 : _b.name }),
            severity: "error",
        });
    }, [notify, t, isExternal]);
    return (0, exports.useFileUploadBase)(params, loadingState, "/api/".concat(isExternal ? "external/" : "", "file/url/voucher"), "/api/".concat(isExternal ? "external/" : "", "file/url/done"), onUploadFinish, onUploadFailure);
};
exports.useVoucherUploadBase = useVoucherUploadBase;
var useVoucherAttachmentUploadBase = function (loadingState, voucherId) {
    var params = (0, react_1.useMemo)(function () { return ({ voucherId: voucherId }); }, [voucherId]);
    var _a = __read((0, react_i18next_1.useTranslation)(), 1), t = _a[0];
    var notify = (0, notification_1.useNotify)();
    var onUploadSuccess = (0, react_1.useCallback)(function (state) {
        notify({
            message: "\u6DFB\u4ED8\u30D5\u30A1\u30A4\u30EB\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3057\u307E\u3057\u305F\u3002",
            severity: "success",
        });
    }, [notify]);
    var onUploadFailure = (0, react_1.useCallback)(function (state) {
        // TODO: エラー内容を出し分けしたい
        notify({
            message: "\u6DFB\u4ED8\u30D5\u30A1\u30A4\u30EB\u306E\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002",
            severity: "error",
        });
    }, [notify]);
    return (0, exports.useFileUploadBase)(params, loadingState, "/api/file/url/attachment", "/api/file/url/attachment/done", onUploadSuccess, onUploadFailure);
};
exports.useVoucherAttachmentUploadBase = useVoucherAttachmentUploadBase;
var useExternalMappingCsvUploadBase = function (loadingState, onFinish) {
    var _a = __read((0, react_i18next_1.useTranslation)(), 1), t = _a[0];
    var notify = (0, notification_1.useNotify)();
    var onUploadFinish = (0, react_1.useCallback)(function (state) {
        notify({
            message: "CSV\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3057\u307E\u3057\u305F\u3002",
            severity: "success",
        });
        onFinish(state);
    }, [notify, onFinish]);
    var onUploadFailure = (0, react_1.useCallback)(function (state) {
        // TODO: エラー内容を出し分けしたい
        notify({
            message: "CSV\u306E\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002",
            severity: "error",
        });
    }, [notify]);
    return (0, exports.useFileUploadBase)({}, loadingState, "/api/file/url/external-mapping", "/api/file/url/external-mapping/done", onUploadFinish, onUploadFailure);
};
exports.useExternalMappingCsvUploadBase = useExternalMappingCsvUploadBase;
